"use client";
import React, { useState } from "react";
import "./components.css";
import { Col, Container, Row } from "react-bootstrap";
import {
  Android,
  Aws,
  Azure,
  Contentful,
  Django,
  Docker,
  Drupal,
  Firebase,
  Flutter,
  GoogleCloud,
  Html,
  Java,
  Javascript,
  Jenkins,
  Joomla,
  Jquery,
  Kotlin,
  Kubernetes,
  Laravel,
  Magento,
  Mongodb,
  MySQL,
  Net,
  NodeJs,
  Nodejs,
  PHP,
  PostgreSQL,
  Python,
  ReactJs,
  ReactNative,
  Strapi,
  Swift,
  Vue,
  WordPress,
} from "./svg";

const tabData = {
  Mobile: [
    { title: "Android", icon: <Android /> },
    { title: "Swift", icon: <Swift /> },
    { title: "React Native", icon: <ReactNative /> },
    { title: "Flutter", icon: <Flutter /> },
    { title: "Kotlin", icon: <Kotlin /> },
    { title: "Java", icon: <Java /> },
  ],
  "Front End": [
    { title: "jquery", icon: <Jquery /> },
    { title: "Javascript", icon: <Javascript /> },
    { title: "HTML5", icon: <Html /> },
    { title: "React Js", icon: <ReactJs /> },
    { title: "Node.js", icon: <Nodejs /> },
    { title: "Vue", icon: <Vue /> },
  ],
  Database: [
    { title: "MySQL", icon: <MySQL /> },
    { title: "Mongo DB", icon: <Mongodb /> },
    { title: "Firebase", icon: <Firebase /> },
    { title: "PostgreSQL", icon: <PostgreSQL /> },
  ],
  Backend: [
    { title: "PHP", icon: <PHP /> },
    { title: "Python", icon: <Python /> },
    { title: "Laravel", icon: <Laravel /> },
    { title: ".Net", icon: <Net /> },
    { title: "Node.js", icon: <NodeJs /> },
    { title: "Django", icon: <Django /> },
  ],
  CMS: [
    { title: "WordPress", icon: <WordPress /> },
    { title: "Joomla", icon: <Joomla /> },
    { title: "Drupal", icon: <Drupal /> },
    { title: "Magento", icon: <Magento /> },
    { title: "Contentful", icon: <Contentful /> },
    { title: "Strapi", icon: <Strapi /> },
  ],
  "Infra and DevOps": [
    { title: "AWS", icon: <Aws /> },
    { title: "Azure", icon: <Azure /> },
    { title: "Google Cloud", icon: <GoogleCloud /> },
    { title: "Docker", icon: <Docker />},
    { title: "Kubernetes", icon: <Kubernetes /> },
    { title: "Jenkins", icon: <Jenkins /> },
  ],
};

const Technologies = () => {
  const [activeTab, setActiveTab] = useState("Mobile");

  return (
    <div className="technologies-main">
      <Container>
        <Row>
          <Col xl={12} className="text-center">
            <div className="com-pill mx-auto mb-4 reveal fade-bottom">
              ~ Our Technologies ~
            </div>
            <h4 className="com-title reveal fade-bottom">
              The <span>technologies</span> we utilize.
            </h4>
          </Col>

          <Col xl={12} className="mt-xl-5">
            <div className="tech-tabs">
              {Object.keys(tabData).map((tab) => (
                <button
                  key={tab}
                  className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div className="tab-content row justify-content-center mt-4 mx-md-5">
              {tabData[activeTab].map((tech, index) => (
                <div
                  className="col-6 col-sm-4 col-md-3 col-lg-2 text-center mb-4"
                  key={index}
                >
                  <div className="tech-box p-3 shadow-sm rounded">
                    <div
                      className="tech-icon mb-4"
                      style={{ fontSize: "2rem" }}
                    >
                      {tech.icon}
                    </div>
                    <div className="tech-title">{tech.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Technologies;
